import { render, staticRenderFns } from "./UpdatePerformanceReportTablePage.vue?vue&type=template&id=25091d34&scoped=true"
import script from "./UpdatePerformanceReportTablePage.vue?vue&type=script&lang=js"
export * from "./UpdatePerformanceReportTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25091d34",
  null
  
)

export default component.exports